"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@xyflow/react");
var react_2 = require("react");
var node_1 = __importDefault(require("./node"));
var ObjectiveNode = function (props) {
    return ((0, jsx_runtime_1.jsx)(node_1.default, __assign({ category: "objective" }, props, { sourceHandle: (0, jsx_runtime_1.jsx)(react_1.Handle, { type: "source", position: react_1.Position.Bottom, style: __assign({
                width: 0,
                height: 0,
            }, { background: "transparent", border: "none" }) }) })));
};
exports.default = (0, react_2.memo)(ObjectiveNode);
